import { RemoveAssociateFromTreaty, RemoveAssociateFromTreatyVariables } from "_graphql/mutation/__generated__/RemoveAssociateFromTreaty";

import { LocationGenerics } from "router/location";
import { PopUp } from "components";
import { removeAssociateFromTreaty } from "_graphql/visal/mutations/treaty";
import toast from "react-hot-toast";
import { useMutation } from "@apollo/client";
import { useSearch } from "react-location";

export default function RemoveReinsurerAssociateContainer({
    open,
    setOpen,
    refetch,
}: {
    open: boolean;
    setOpen: (val: boolean) => void;
    refetch?: () => void;
}) {
    const searchParams = useSearch<LocationGenerics>()
    const [remove, { loading }] = useMutation<RemoveAssociateFromTreaty, RemoveAssociateFromTreatyVariables>(removeAssociateFromTreaty, {
        refetchQueries: ["GetTreatyReinsurerAssociates"]
    });


    const handleSubmit = async () => {
        await remove({
            variables: {
                treatyToAssociateId: searchParams?.id || ""
            },
        }).then(({ data }) => {
            if (data?.removeAssociateFromTreaty) {
                toast.success("Associate Removed");
                refetch?.();
                setOpen?.(false);
            } else {
                toast.error("Failed to remove Associate");
            }
        });
    }

    return (
        <PopUp
            open={open}
            setOpen={setOpen}
            title="Remove Associate"
            cancelText="No, Don't Remove Associate"
            description="This action would completely remove  associate details from system"
            renderActions={() => (
                <>
                    <button
                        type="button"
                        disabled={loading}
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={handleSubmit}
                    >
                        {loading ? "Removing Associate..." : "Remove Associate"}
                    </button>
                </>
            )}
        />
    );
}
